export default __webpack_public_path__ + "static/media/css2.ac7867b5.svg";